import client from './client';
import { createCategoryApi } from './categories';

const PATH = '/api/videos/videos/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (slug) => client.get(`${PATH}${slug}/`).then((r) => r.data);

export const videoApi = {
  list,
  detail,

  create(payload) {
    return client.post(PATH, payload).then((r) => r.data);
  },

  update(slug, payload) {
    return client.patch(`${PATH}${slug}/`, payload).then((r) => r.data);
  },

  remove(slug) {
    return client.delete(`${PATH}${slug}/`).then((r) => r.data);
  },

  publish(slug) {
    return client.post(`${PATH}${slug}/publish/`).then((r) => r.data);
  },

  unpublish(slug) {
    return client.post(`${PATH}${slug}/unpublish/`).then((r) => r.data);
  },

  categories: createCategoryApi('videos'),
};
